import { useTheme } from '@mui/material'

const CircleUpIcon = () => {
  const theme = useTheme()

  return (
    <svg width="33" height="31" viewBox="0 0 33 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5002 30.4635C7.64059 30.4635 0.458496 23.7021 0.458496 15.3616C0.458496 7.0211 7.64059 0.259766 16.5002 0.259766C25.3597 0.259766 32.5418 7.0211 32.5418 15.3616C32.5418 23.7021 25.3597 30.4635 16.5002 30.4635ZM16.5002 27.7177C23.7489 27.7177 29.6252 22.1857 29.6252 15.3616C29.6252 8.53755 23.7489 3.00555 16.5002 3.00555C9.25142 3.00555 3.37516 8.53755 3.37516 15.3616C3.37516 22.1857 9.25142 27.7177 16.5002 27.7177ZM9.63567 17.1366L11.6981 19.0782L16.5002 14.5574L21.3023 19.0782L23.3647 17.1366L16.5002 10.6742L9.63567 17.1366Z"
        fill={theme.palette.custom.darkBlue2}
      />
    </svg>
  )
}

export default CircleUpIcon
